<template>
  <div
    class="action-button"
    :class="buttonClass"
    role="presentation"
  >
    <component
      :is="popoverTrigger ? 'span' : getComponent(button)"
      class="action-button-inner"
      :class="buttonInnerClass"
      :role="popoverTrigger ? 'presentation' : 'button'"
      :type="popoverTrigger ? undefined : 'button'"
      placement="bottom"
      :title="popoverTrigger ? undefined : $t(button.label(funcArg))"
      target="_blank"
      :tabindex="popoverTrigger ? undefined : 0"
      :disabled="!isInteractive"
      :href="href"
      @click="popoverTrigger ? undefined : doActionWrap(button, outerClose)"
    >
      <FALayers role="presentation">
        <FAIcon
          class="fa-scale-110"
          :icon="button.icon(funcArg)"
          :spin="!extra && getComponent(button) == 'button' && button.animated?.() && animationState"
          :style="{ '--fa-animation-duration': '750ms' }"
          fixed-width
        />
        <template v-if="!buttonClass.disabled && (!button.interactive || button?.interactive(funcArg)) && button.toggleable?.(funcArg) && button.active">
          <FAIcon
            v-if="button.active(funcArg) && button.activeIndicator?.() !== null"
            class="active-marker"
            transform="shrink-6 up-9 left-12"
            :icon="button.activeIndicator?.(funcArg) || 'check'"
          />
          <FAIcon
            v-if="!button.active(funcArg)"
            class="focus-marker"
            transform="shrink-6 up-9 left-12"
            :icon="button.openIndicator?.(funcArg) || 'plus'"
          />
          <FAIcon
            v-else
            class="focus-marker"
            transform="shrink-6 up-9 left-12"
            :icon="button.closeIndicator?.(funcArg) || 'minus'"
          />
        </template>
      </FALayers>
      <span
        v-if="extra"
        class="action-label"
      >
        {{ $t(button.label(funcArg)) }}
      </span>
      <FAIcon
        v-if="button.dropdown?.()"
        class="chevron-icon"
        :icon="extra ? 'chevron-right' : 'chevron-down'"
        fixed-width
      />
    </component>
    <span
      v-if="!hidePostStats && button.counter?.(funcArg) > 0 && !hideLabel"
      class="action-counter"
      :aria-label="$t(`status.${button.counterLabel()}`, [button.counter?.(funcArg)])"
    >
      {{ button.counter?.(funcArg) }}
    </span>
    <span
      v-if="!extra && button.name === 'bookmark'"
      class="separator"
    />
    <Popover
      v-if="button.name === 'bookmark'"
      class="extra-button"
      :trigger="extra ? 'hover' : 'click'"
      :placement="extra ? 'right' : 'bottom'"
      :offset="extra ? { x: 10 } : { y: 10 }"
      :aria-label="$t('nav.bookmark_folders')"
    >
      <template #trigger>
        <FAIcon
          class="chevron-icon"
          :icon="extra ? 'chevron-right' : 'chevron-down'"
          fixed-width
        />
      </template>
      <template #content="{close}">
        <StatusBookmarkFolderMenu
          v-if="button.name === 'bookmark'"
          :status="status"
          @close="() => { close(); outerClose?.() }"
        />
      </template>
    </Popover>
  </div>
</template>

<script src="./action_button.js" />

<style lang="scss" src="./action_button.scss" />
